import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authSlice, { logout } from "./reducers/authSlice";
import chatSlice from "./reducers/chatSlice";
import clinicSlice from "./reducers/clinicSlice";
import doctorSlice from "./reducers/doctorSlice";
import loaderSlice from "./reducers/loaderSlice";
import medicalHistorySlice from "./reducers/medicalHistorySlice";
import mixedSlice from "./reducers/mixedSlice";
import notificationSlice from "./reducers/notificationSlice";
import paymentSlice from "./reducers/paymentSlice";
import petSlice from "./reducers/petSlice";
import planSlice from "./reducers/planSlice";
import recorderSlice from "./reducers/recorderSlice";
import snackSlice from "./reducers/snackSlice";
import vetSlice from "./reducers/vetSlice";
import dashboardReducer from "./reducers/dashboardSlice";
// import doctorDashboardReducer from './slices/doctorDashboardSlice';
import doctorDashboardReducer from "./reducers/doctorDashboardSlice";
import specialitySlice from './reducers/specialitySlice';
import paymentDashboardReducer from './reducers/paymentDashboardSlice';
import serviceDashboardReducer from './reducers/serviceDashboardSlice';
import stockDashboardReducer from './reducers/stockDashboardSlice';
import speciesSlice from './reducers/speciesSlice';
import breedReducer from "./reducers/breedSlice";
import roleSlice from './reducers/roleSlice';
import departmentSlice from'./reducers/departmentSlice';
import serviceSlice from './reducers/serviceSlice';
import productSlice from './reducers/productSlice';
import vitalSlice from './reducers/vitalsSlice';
import groupReducer from './reducers/groupSlice';
import consultationRoomSlice from './reducers/consultationRoomSlice';
import operationTheatreSlice from './reducers/operationTheatreSlice';
import kennelSlice from './reducers/kennelSlice';
import deviceSlice from "./reducers/deviceSlice";
import bathBaySlice from "./reducers/bathBaySlice";
import paymentMethodReducer from './reducers/paymentMethodSlice';
import discountSlice from "./reducers/discountSlice"; 
import scheduleReducer from './reducers/scheduleSlice';
import templateSlice from "./reducers/templateSlice";
import appointmentReducer from './reducers/appointmentSlice';
import appointmentTypeReducer from './reducers/appointmentTypeSlice';
import timeSlotReducer from './reducers/timeSlotSlice';

const appReducer = combineReducers({
  auth: authSlice,
  loader: loaderSlice,
  snack: snackSlice,
  clinic: clinicSlice,
  pet: petSlice,
  vet: vetSlice,
  payment: paymentSlice,
  doctor: doctorSlice,
  medicalHistory: medicalHistorySlice,
  notification: notificationSlice,
  mixed: mixedSlice,
  recorder: recorderSlice,
  chat: chatSlice,
  plan: planSlice,
  dashboard: dashboardReducer,
  doctorDashboard: doctorDashboardReducer,
  paymentDashboard: paymentDashboardReducer,
   serviceDashboard: serviceDashboardReducer,
  stockDashboard: stockDashboardReducer,
   species: speciesSlice,
   breed: breedReducer, speciality: specialitySlice,
   role: roleSlice,
    department: departmentSlice,
    service: serviceSlice,
product: productSlice,
 vital: vitalSlice,
 group: groupReducer,
 consultationRoom: consultationRoomSlice,
 operationTheatre: operationTheatreSlice,
  kennel: kennelSlice,
 device: deviceSlice,
 bathBay: bathBaySlice, 
 paymentMethod: paymentMethodReducer,
 discount: discountSlice,
 schedule: scheduleReducer,
 template: templateSlice,
 appointments: appointmentReducer,
 appointmentTypes: appointmentTypeReducer,
 timeSlot: timeSlotReducer,
 
});

const rootReducer = (state, action) => {
  if (action.type === logout.type) {
    state = undefined;
  }
  return appReducer(state, action);
};

export default configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disables the serializable check
    }),
});
